export default __webpack_public_path__ + "static/media/fidelity.0a9a823f.png";